import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate, AnimationTriggerMetadata } from '@angular/animations';

const fadeOutAnimation: AnimationTriggerMetadata = trigger('fadeOut', [
  state('visible', style({
    opacity: 1
  })),
  state('hidden', style({
    opacity: 0,
    visibility: 'hidden'
  })),
  transition('visible => hidden', [
    animate('0.5s ease-out')
  ])
]);

const scaleInAnimation: AnimationTriggerMetadata = trigger('scaleIn', [
  transition(':enter', [
    style({ transform: 'scale(0.8)', opacity: 0 }),
    animate('0.5s ease-out', style({ transform: 'scale(1)', opacity: 1 }))
  ])
]);

const spinAnimation: AnimationTriggerMetadata = trigger('spin', [
  transition('* => *', [
    animate('2s linear', style({ transform: 'rotate(360deg)' }))
  ])
]);

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.html',
  styleUrl: './loading.scss',
  animations: [
    fadeOutAnimation,
    scaleInAnimation,
    spinAnimation
  ]
})
export class LoadingComponent implements OnInit, AfterViewInit {
  isVisible = true;

  ngOnInit() {
    // This is a splash screen only. Never block the UI waiting on data.
    // Hide quickly; route/components should show their own local spinners if needed.
    this.hideLoader();
  }

  ngAfterViewInit() {
    // Keep for at most ~0.8s total to avoid the "stuck" feeling.
    setTimeout(() => {
      this.isVisible = false;
    }, 800);
  }

  private hideLoader() {
    setTimeout(() => (this.isVisible = false), 200);
  }
}

